import React from 'react';

import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import SectionContainer from '../SectionContainer';
import PageHeading from '../PageHeading';
import { analytics } from '../../utils/common';

const ErrorContent = () => {
  analytics('404 Shiatsu - Page Not Found');

  const headerText = 'This page does not exist';
  return (
    <div className="appWrap">
      <div className="MainContentWrap mt3">
        <Header showHamburgerMenu />
        <div className="footerMarginContainer">
          <PageHeading mobileTitle={headerText}>{headerText}</PageHeading>
          <div className="exit-booking__content">
            <div className="exit-booking__stripes subhdr-stripes subhdr-stripes--sub subhdr-stripes--ucase hide-phone">
              <span className="stripes-bg" />
            </div>
            <div className="exit-booking__content-wrap">
              <div className="exit-booking__bubble">
                <div className="bubble">
                  <p className="exit-booking__bubble-text">Oh Shiatsu!</p>
                </div>
                <i className="icon icon--frown-reflection" />
              </div>
            </div>
          </div>
          <SectionContainer />
        </div>
      </div>
      <div className="FootContentWrap">
        <Footer />
      </div>
    </div>
  );
};

export default ErrorContent;
